import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() => ({
  questionContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    marginBottom: '2rem'
  }
}));
